import { FC, useEffect, useState } from "react";
import { PartsRequestViewModel } from "../../../../interfaces";
import { Button, Image, Input, Modal, Select, Table } from "antd";
import { useSelector } from "react-redux";
import { AuthenticationState } from "../../../../interfaces/users";
import { api } from "../../../../config";
import { toast } from "react-toastify";
import { useQuery } from "react-query";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { onChangeCurrencyInput } from "../../../Kanban/SingleTicketModal";
const { confirm } = Modal;

interface PartsRequestListProps {
  PartsRequest: PartsRequestViewModel[];
}

const selectOptions: { value: string; label: string; description: string }[] = [
  {
    value: "AUTOMATIC_REQUEST",
    label: "Solicitação Automatica",
    description:
      "O sistema removerá a peça solicitada deste ticket e a moverá para a coluna <b>'Aguardando Peça'</b>.",
  },
  {
    value: "INTEGRAL_SUPPORT",
    label: "Assistencia Integral",
    description:
      "O ticket será movido <b>integralmente</b> para a coluna <b>'Aguardando Peça'</b>, garantindo que o pagamento só seja efetuado <b>após a conclusão do serviço técnico</b>.",
  },
];

export const PartsRequestList: FC<PartsRequestListProps> = ({
  PartsRequest,
}) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const { refetch, data: ticket } = useQuery(
    "tickets/assemble",
    () => api(token).get(`ticket/assemble/${PartsRequest[0].fieldReportId}`),
    { refetchOnMount: false }
  );
  const { refetch: boardRefetch } = useQuery([`tickets/assemble/board`], () =>
    api(token).get(`tickets/assemble/board`)
  );

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [optionSelected, setOptionSelected] = useState<any>();
  const getTotalTicket = () => {
    return ticket.products.reduce(
      (acc: number, product: any) => acc + product.value,
      0
    );
  };
  const [newTicketValue, setNewTicketValue] = useState<any>(getTotalTicket().toFixed(2).replace(".", ","));
  const [newPartsValue, setNewPartsValue] = useState<any>((0).toFixed(2).replace(".", ","));
  const [reason, setReason] = useState<string | undefined>('TRANSPORT');


  const handleApprovePartsRequest = async () => {
    if (optionSelected === "INTEGRAL_SUPPORT" || newTicketValue <= 0) {
      showConfirmModal();
    } else {
      await approvePartsRequest();
    }
  };

  const showConfirmModal = () => {
    confirm({
      title: "Mover Ticket",
      icon: <ExclamationCircleFilled />,
      content: (
        <>
          Tem certeza de que deseja mover este ticket para a coluna{" "}
          <b>"Aguardando Peça"</b>?<br />A aprovação ou rejeição só será
          possível após a conclusão da assistência técnica.
        </>
      ),
      okButtonProps: { loading: loading },
      okText: "Mover",
      centered: true,
      onOk() {
        approvePartsRequest();
      },
      onCancel() {},
    });
  };

  const approvePartsRequest = async () => {
    try {
      setLoading(true);

      await api(token).post("parts-request/approve", {
        partsRequestIds: PartsRequest.map((part) => part.id),
        fieldReportId: PartsRequest[0].fieldReportId,
        type: newTicketValue ? optionSelected : "INTEGRAL_SUPPORT",
        newTicketValue: Number(newTicketValue.replace(",", ".")),
        newPartsValue: Number(newPartsValue.replace(",", ".")),
        reason
      });
      toast.success("Solicitação de peça aprovada com sucesso");
      refetch();
      boardRefetch();
    } catch (error: any) {
      toast.error(
        error?.response?.data?.error ??
          "Ocorreu um erro ao aprovar a solicitação de peça"
      );
    } finally {
      setLoading(false);
    }
  };

  const getValorDasPecas = () => {
    let total = 0;
    PartsRequest.forEach((part) => {
      part.PartsRequestProduct.forEach((part) => {
        if (part.product?.fieldReportProduct?.[0])
          total += part.product.fieldReportProduct[0].value;
      });
    });
    return total;
  };
  return (
    <>
      <Modal
        title="Tipo de Solicitação"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        className="min-w-[700px]"
        okButtonProps={{ loading: loading }}
        onOk={handleApprovePartsRequest}
      >
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-4  justify-center items-center">
            <Select
              title="Tipo de Solicitação"
              placeholder="Selecione"
              defaultValue={optionSelected}
              onChange={(value) => setOptionSelected(value)}
              style={{ width: "100%" }}
            >
              {selectOptions.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>

            <div
              className="text-center"
              dangerouslySetInnerHTML={{
                __html:
                  selectOptions.find(
                    (option) => option.value === optionSelected
                  )?.description || "",
              }}
            ></div>
          </div>
          {optionSelected === "AUTOMATIC_REQUEST" && (
            <>
              <div>
                <Table
                  bordered
                  dataSource={[
                    {
                      description: "Valor Total a Pagar",
                      value:
                        "R$ " + getTotalTicket().toFixed(2).replace(".", ","),
                    },
                    {
                      description: "Valor em Aberto a Pagar",
                      value:
                        "R$ " + getValorDasPecas().toFixed(2).replace(".", ","),
                    },
                    {
                      description: "Valor a Pagar Aprovado",
                      value:
                        "R$ " +
                        (getTotalTicket() - getValorDasPecas())
                          .toFixed(2)
                          .replace(".", ","),
                    },
                  ]}
                  rowKey="id"
                  pagination={false}
                >
                  <Table.Column dataIndex="description" key="description" />
                  <Table.Column dataIndex="value" key="value" />
                </Table>
              </div>
              <p>Motivo da Solicitação:</p>
              <Select
                value={reason}
                onChange={(e) => setReason(e)}
              >
                <Select.Option value="TRANSPORT">
                  Avaria no Transporte
                </Select.Option>
                <Select.Option value="MISSING">Peças Faltando</Select.Option>
                <Select.Option value="ASSEMBLER_ERROR">
                  Erro de Montagem
                </Select.Option>
                <Select.Option value="SELLER_ERROR">
                  Erro de Venda
                </Select.Option>
                <Select.Option value="MEASURING_ERROR">
                  Erro de Medição
                </Select.Option>
                <Select.Option value="FACTORY_ERROR">
                  Erro de Fábrica
                </Select.Option>
              </Select>
              <div className="flex justify-between w-4/5 mx-auto ">
                <div className="flex flex-col justify-center text-center">
                  <b>Aprovado para Pagamento</b>
                  <div>
                    <Input
                      style={{ width: "60%" }}
                      prefix="R$"
                      value={newTicketValue}
                      onChange={(element) => {
                        onChangeCurrencyInput(
                          element.target.value,
                          setNewTicketValue,
                          6
                        );
                      }}
                      placeholder="0,00"
                    />
                  </div>
                </div>
                <div className="flex flex-col justify-center text-center">
                  <b>Valor em Aberto</b>
                  <div>
                    <div>
                      <Input
                        style={{ width: "60%" }}
                        prefix="R$"
                        defaultValue={newPartsValue}
                        onChange={(element) => {
                          const val = Number(
                            element.target.value
                              .replace(/[^\d,]/g, "")
                              .replace(",", ".")
                          );

                          onChangeCurrencyInput(
                            element.target.value,
                            setNewPartsValue
                          );
                        }}
                        placeholder="0,00"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center text-red-500 font-bold text-center gap-3 flex-col">
                {newTicketValue - newPartsValue < 0 && (
                  <div>
                    {`Atenção, o valor da assistência técnica esta superior ao valor do ticket!`}
                  </div>
                )}
                {newTicketValue <= 0 && (
                  <div>{`Atenção, o valor do ticket esta zerado, dessa forma o ticket ira ser movido para a coluna 'Aguardando Peça' integralmente!`}</div>
                )}
              </div>
            </>
          )}
        </div>
      </Modal>

      {!!PartsRequest.length && (
        <>
          <div className="flex flex-col w-1/2 mx-auto">
            <div className="flex justify-center">
              <p className="text-2xl font-semibold">
                Solicitações de Peça/Assistencia Técnica
              </p>
            </div>
            <div>
              {PartsRequest.map((part) => (
                <div
                  key={part.id}
                  className="rounded shadow-lg border-black p-5"
                >
                  <div className="flex gap-2 w-full">
                    <p className="w-1/4">
                      <b>Título:</b>
                    </p>
                    <p className="w-3/4">{part.name}</p>
                  </div>
                  <div className="flex gap-2 w-full">
                    <p className="w-1/4">
                      <b>Produto: </b>
                    </p>
                    <p className="w-3/4">
                      {part.PartsRequestProduct[0].product.description}
                    </p>
                  </div>
                  <div className="flex gap-2 w-full">
                    <p className="w-1/4">
                      <b>Status: </b>
                    </p>
                    <p className="w-3/4">
                      {part.status === "PENDING_APPROVEMENT"
                        ? "Pendente de Aprovação"
                        : "Aprovado"}
                    </p>
                  </div>
                  <div className="flex w-full gap-2">
                    <p className="w-1/4">
                      <b>Imagens: </b>
                    </p>
                    <div className="w-3/4 flex gap-2">
                      {part.PartsRequestProduct[0].issueImages.map((image) => (
                        <Image
                          key={image.id}
                          src={image.url}
                          alt={image.fileName}
                          className="w-1/4 h-auto"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Button
            type="primary"
            loading={loading}
            className="w-fit mx-auto"
            onClick={() => setIsModalOpen(true)}
          >
            Enviar Solicitações
          </Button>
        </>
      )}
    </>
  );
};
